import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { LoginText } from '../../components/logo';
import Image from '../../components/image';
import PRSLogo from '../../assets/logo.png';
import LoginLayout from '../../layouts/login';
import AuthLoginForm from './AuthLoginForm';
import { PATH_AUTH } from '../../routes/paths';
import { isValidToken, setSession } from '../../auth/utils';
import axios from '../../utils/axios';

export default function Login() {
  const navigate = useNavigate();
  useEffect(() => {
    // Admin SSO hash is applied in index.tsx before render.

    // Regular case: if already logged in, go to dashboard; otherwise stay on login
    const existingToken = localStorage.getItem('accessToken');
    if (existingToken && isValidToken(existingToken)) {
      setSession(existingToken);
      // Prefetch brokers so broker dropdown has data immediately
      void (async () => {
        try {
          const res = await axios.get('/user/brokers');
          localStorage.setItem('brokers_cache', JSON.stringify(res?.data ?? []));
        } catch {
          // ignore: page can still load and fetch on demand
        }
      })();
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  return (
    <LoginLayout>
      <Stack spacing={-6} sx={{ mb: 5, position: 'relative' }}>
        <Image
          disabledEffect
          visibleByDefault
          alt="auth"
          src={PRSLogo}
          sx={{
            width: { lg: 180, md: 150, sm: 130, xs: 120 },
            mb: { lg: 10, md: 8, sm: 5, xs: 4 },
            height: 'auto',
            alignSelf: 'center',
          }}
        />
        <Typography variant="h4">PRS Client Portal Login</Typography>
      </Stack>
      <AuthLoginForm />
      <Typography sx={{ mt: 1 }}>
        Click here to{' '}
        <Button
          onClick={() => navigate(PATH_AUTH.signUp)}
          sx={{ background: 'none', color: '#22345B' }}
        >
          <span style={{ fontWeight: 'bold' }}>Sign up</span>
        </Button>
      </Typography>
      <LoginText
        sx={{
          zIndex: 9,
          position: 'absolute',
          bottom: 0,
          color: '#22345B',
          mb: { xs: 1.5, md: 3 },
          mr: { xs: 2, md: 5 },
        }}
      />
    </LoginLayout>
  );
}
